import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from "@mui/material/Toolbar";
import {Person} from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import ProfileContent from "@/components/admin/ProfileContent";

const Profile = () => {
    return (
    <>
        <AppBar position="relative" sx={{background:'white', color:'black'}}>
            <Toolbar sx={{ml:10}}>
                <Person sx={{ mr: 2 }} />
                <Typography variant="h6" color="inherit" noWrap>
                    Profile
                </Typography>
            </Toolbar>
        </AppBar>


        <ProfileContent />


    </>
        );
};

export default Profile;